import { getCountryRegions } from "../../../../axios/api/services";
import createAppDataSliceAndThunk from "./appDataSlice";

const [asyncThunk, slice] = createAppDataSliceAndThunk("countryRegions", getCountryRegions);

export const countryRegionsThunk = asyncThunk;

export default slice.reducer;
